<template>
    <div class="row bgc-wrapper">
        <div class="plan-card-outer mt-5 mx-0">
            <div class="row px-lg-3 px-md-3 plan-card-custom-padding">
                <div  class="col-md-1 col-lg-1 col-sm-1 col-1 pl-0">
                    <img class="plan-image triangle-right" src="@/assets/images/Artboard4.png" /> <span class="card-heading-text"><small class="">Re-Calculated</small> Premium</span>
                </div>
                <div class="col-md-8 col-lg-8 col-sm-11 col-11 p-4 pl-5 mt-2 mt-sm-3">
                    <h5 class="font-weight-bold plan-name">{{planCode}} - {{planName}}</h5>
                </div>
                <div class="col-md-3 col-lg-3 col-sm-12">
                    <div class="row text-center">
                        <div class="col-md-4 col-lg-4 col-sm-0 display-premium-none premium-display text-right pt-2 pr-4" :class="{'previous-premium' : !motorParent}">
                            <span class="premium-text" v-show="!motorParent">Previous<br> 
                                Premium<br></span>
                            <span class="premium-amount" v-show="!motorParent">₹ {{previousPremium}}</span>
                        </div>
                        <div class="col-md-8 col-lg-8 col-sm-12 premium-display text-lg-right text-md-right mx-md-auto mx-sm-auto premium-block-border pt-2 pr-4">
                            <span class="premium-text">Re-Calculated<br> 
                                Premium<br></span>
                            <span class="premium-amount">₹ {{newPremium}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
// import { reactive } from '@vue/composition-api';
export default {
  name: "ReCalculatePremium",
  props: ['previousPremium','newPremium','planName','planCode','motorParent'],
  components: {
    FloatLabel
  }
};
</script>
<style scoped>
.plan-card-outer{
    display: block;
    width: 100%;
    height: 100px;
    border: 1px solid #c7c7c7;
    border-radius: 10px;
}
.plan-image{
    position: relative;
    top: -23px;
    right: 4px;
}
.premium-display{
    display: block;
    height: 100px;
    position: relative;
    left: 2px;
}
.premium-block-border{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #0070be;
}
.previous-premium{
    background: #c7c7c7
}
.premium-amount{
    font-size: 23px;
    text-decoration: none;
    color: white;
    font-weight: bold;
}
.premium-text{
    color: white;
    font-weight: bold;
    font-size: 17px;
}
.card-heading-text{
    color: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 21px;
    left: 43px;
}
    @media (max-width: 911px){
    .premium-amount{
        font-size: 15px;
    }
    .premium-text{
        font-size: 14px;
    }
    .plan-name{
        font-size: 15px;
        position: relative;
        left: 20px;
    }
}
@media (max-width: 767px){
    .plan-card-outer{
        height: auto;
        display: block;
        width: 100%;
        border: 1px solid #c7c7c7;
        border-radius: 10px;
    }
    .plan-card-custom-padding{
        padding-right: 17px;
        padding-left: 13px;
    }
    .previous-premium{
        border-bottom-left-radius: 8px;
    }
    .premium-block-border{
        border-top-right-radius: 0px;
        border-bottom-left-radius: 10px;
    }
    .display-premium-none{
        display: none;
    }
    .plan-name, .premium-amount{
        font-size: 20px;
    }
    .premium-text{
        font-size: 18px;
    }
}
@media (max-width: 575px){
    .plan-name{
        font-size: 16px;
        position: relative;
        left: 35px;
        top: 8px;
    }
    .previous-premium{
        border-bottom-left-radius: 0px;
    }
} 
</style>

